import { ErrorCode } from "./rest-api";

export const ERROR_MESSAGES: Partial<Record<ErrorCode, string>> = {
	[ErrorCode.INVALID_CREDENTIALS]: "Mật khẩu hoặc tài khoản không đúng.",
	[ErrorCode.EMAIL_ALREADY_IN_USE]: "Email đã được sử dụng.",
	[ErrorCode.ACCOUNT_NOT_VERIFIED]:
		"Tài khoản chưa được xác minh, vui lòng kiểm tra lại email của bạn.",
	[ErrorCode.ACCOUNT_NOT_FOUND]: "Không tìm thấy tài khoản.",
	[ErrorCode.ACCOUNT_LOCKED]: "Tài khoản này đã bị khoá.",
	[ErrorCode.ACCOUNT_VERIFIED]: "Tài khoản đã được xác thực.",
	[ErrorCode.ACCOUNT_VERIFICATION_FAILED]: "Xác thực tài khoản thất bại.",
	[ErrorCode.INVALID_LOGIN_METHOD]: "Phương thức đăng nhập không hợp lệ.",
	[ErrorCode.EMAIL_IN_USE_DIFFERENT_METHOD]:
		"Email đã được sử dụng để đăng nhập bằng phương thức khác.",
	[ErrorCode.OLD_PASSWORD_DIFF_NEW_PASSWORD]:
		"Mật khẩu cũ phải khác với mật khẩu mới.",
	[ErrorCode.NEW_PASSWORD_SAME_AS_OLD_PASSWORD]:
		"Mật khẩu cũ phải khác với mật khẩu mới.",
	[ErrorCode.OLD_PASSWORD_INCORRECT]: "Mật khẩu cũ không chính xác.",
	[ErrorCode.INSUFFICIENT_PRIVILEGES]: "Bạn không đủ quyền thực hiện điều này.",
	[ErrorCode.PHONE_NUMBER_NOT_UPDATED]:
		"Bạn chưa cập nhập số điện thoại của mình trong hồ sơ.",
	[ErrorCode.MEMBERSHIP_PRICE_HAS_PAID_CANNOT_DELETE]:
		"Không thể xóa Subscription Plan vì đã có người dùng đăng ký.",
	[ErrorCode.SUBSCRIPTION_ALREADY_ACTIVE]: "Bạn đã đăng ký gói này!",
	[ErrorCode.SUBSCRIPTION_CARD_TOKEN_NOT_FOUND]:
		"Thông tin thẻ thanh toán không hợp lệ.",
	[ErrorCode.SUBSCRIPTION_ALREADY_LIFETIME]: "Bạn đã đăng ký gói trọn đời.",
	[ErrorCode.EMAIL_COLLECTION_ALREADY_EXISTS]:
		"Địa chỉ email này đã được đăng ký trước đó.",
	[ErrorCode.VOUCHER_NOT_FOUND]: "Không tìm thấy mã giảm giá.",
	[ErrorCode.VOUCHER_CODE_EXISTS]: "Mã giảm giá đã tồn tại.",
	[ErrorCode.VOUCHER_NOT_APPLICABLE]:
		"Mã giảm giá không áp dụng cho sản phẩm này.",
	[ErrorCode.VOUCHER_INACTIVE]: "Mã giảm giá không hoạt động.",
	[ErrorCode.VOUCHER_NOT_STARTED]: "Mã giảm giá chưa hoạt động.",
	[ErrorCode.VOUCHER_EXPIRED]: "Mã giảm giá đã hết hạn.",
	[ErrorCode.VOUCHER_USAGE_LIMIT_REACHED]:
		"Mã giảm giá đã đạt giới hạn sử dụng.",
	[ErrorCode.VOUCHER_PRODUCT_DUPLICATED]:
		"Sản phẩm đã có mã giảm giá với mã giống nhau.",
	[ErrorCode.SURVEY_ALREADY_SUBMITTED]: "Khảo sát này đã được gửi.",
	[ErrorCode.SURVEY_LINKED_TO_PRODUCTS]:
		"Không thể xóa khảo sát đang được gán vào sản phẩm.",
	[ErrorCode.SURVEY_REQUIRED_AUTHORIZATION]:
		"Tài khoản đã tồn tại, vui lòng đăng nhập để tiếp tục.",
	[ErrorCode.SURVEY_NOT_FOUND]: "Không tìm thấy khảo sát.",
	[ErrorCode.SURVEY_RESULT_NOT_FOUND]: "Kết quả khảo sát không tìm thấy.",
	[ErrorCode.SURVEY_EMAIL_REQUIRED]: "Vui lòng không bỏ trống email.",
};

export const getErrorMessage = (
	errorCode: string,
	defaultValue: string = "",
): string => {
	return ERROR_MESSAGES[errorCode as ErrorCode] || defaultValue || errorCode;
};
